import Validation from './validation/plugin'

export default {
  install(app) {
    app
      .use(Validation)
  }
}